interface PreviewWithNameAndExpiry {
  name: string
  expiryDate: string | null
}

export const sortByExpiryDateAndName = (
  a: PreviewWithNameAndExpiry,
  b: PreviewWithNameAndExpiry
) => {
  // If neither has an expiry date, sort alphabetically by name
  if (!a.expiryDate && !b.expiryDate) return a.name.localeCompare(b.name)

  // If only one has an expiry date, prioritize the one with a date
  if (!a.expiryDate) return 1
  if (!b.expiryDate) return -1

  // Both have expiry dates, sort by date (most in the future first)
  const dateA = new Date(a.expiryDate).getTime()
  const dateB = new Date(b.expiryDate).getTime()

  return dateB - dateA || a.name.localeCompare(b.name)
}
